<template>
  <div class="container-error">
    <div class="panel-body">
      <div class="error-image">
        <div class="error-image__outer-display">
          <div class="error-image__inner-display">
            <div class="error-image__header">
              <div class="error-image__dots"></div>
            </div>
            <div class="error-image__viewport" :class="$store.state.TClrs">
              <div class="error-image__dashed-container">
                <div style="margin: auto;">
                  <font-awesome-icon icon="fa-solid fa-skull-crossbones" style="margin-right: 5px;" />
                  <b>Error!</b> <br />
                  <small>Please try again in a few minutes </small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="error-image__stand">
          <div class="error-image__top-stand"></div>
          <div class="error-image__bottom-stand"></div>
        </div>
        <div class="error-image__addons">
          <div class="error-image__plus"></div>
          <div class="error-image__plus"></div>
          <div class="error-image__circle"></div>
          <div class="error-image__circle"></div>
          <div class="error-image__plus"></div>
          <div class="error-image__circle"></div>
          <div class="error-image__plus"></div>
          <div class="error-image__circle"></div>
          <div class="error-image__circle"></div>
        </div>
      </div>
    </div>
    <div class="panel-description">
      <div class="alert errInfo">
        <h6 class="text-start">Chart Generation Failed. You can </h6>
        <ul class="bulletList">
          <li>Click <a class="cursor-pointer mailLink" @click="tryReloadC()">here</a> to reload widget</li>
          <li>Retry Changing the Filters</li>
          <li v-show="!hideMailLi">
            <div style="margin-top: -30px;">
              Click <a class="cursor-pointer mailLink" @click="sendErr(11)"
                style="margin-left: -15px;margin-right: 20px;">
                <div class="letter-image">
                  <div class="animated-mail">
                    <div class="back-fold"></div>
                    <div class="letter">
                      <div class="letter-border"></div>
                      <div class="letter-title"></div>
                      <div class="letter-context"></div>
                      <div class="letter-stamp">
                        <div class="letter-stamp-inner"></div>
                      </div>
                    </div>
                    <div class="top-fold"></div>
                    <div class="body"></div>
                    <div class="left-fold"></div>
                  </div>
                </div>
              </a> to report issue to
              Support Team
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import {
  useRoute
} from 'vue-router';
export default {
  name: 'apiErrorComponent',
  props: {
    compTitle: String,
    compId: String,
    hideSendEmail: Boolean,
  },
  data() {
    return {
      // compTitle: '',
      hideMailLi: this.hideSendEmail,
    }
  },
  mounted() {
  },
  methods: {
    tryReloadC() {
      this.$emit('tryReload')
    },
    sendErr(val) {
      let insightInfoGlobal = this.$sessionData.get('insightInfoGlobal')
      let asgid = this.$sessionData.get('asgID404')
      let wgtName = this.compTitle
      let startdate = insightInfoGlobal.startdate;
      let enddate = insightInfoGlobal.enddate;
      let Analyzefield = insightInfoGlobal.analysison[0].dbname;
      let filtervals = "";
      let analyzeflds;
      let pushdispvals = {};
      let getdropsdata = insightInfoGlobal.dropdata
      let portlevels = insightInfoGlobal.prior_op
      for (let i = 0; i < insightInfoGlobal.prior_op.length; i++) {
        pushdispvals = getdropsdata.find(x => x.dbname === insightInfoGlobal.prior_op[i].filter_key)
        portlevels[i].filterDisp = pushdispvals.name
        analyzeflds = pushdispvals.name
      }
      filtervals = JSON.stringify(analyzeflds);
      let filterlvls = "filterlvlNone";
      let elemt = document.getElementById(this.compId)
      let screen = {
        width: elemt.clientWidth,
        height: elemt.clientHeight
      }
      let sendermail = this.$sessionData.get('uinofo_sess').mailto;
      let subject = "OPSight Azure Support : Reporting Widget Error Issue";
      let yourMessage = "Hi Support team," +
        "\n\nBelow are the details that are captured for this widget error:\n";
      yourMessage += "Assessment ID : " + asgid + "\n";
      yourMessage += "Widget Name: " + wgtName + "\n";
      yourMessage += "Date Period : " + startdate + '-' + enddate + "\n";
      if (Analyzefield != undefined) {
        yourMessage += "Analysis Based on : " + Analyzefield + "\n";
      }
      if (filtervals) {
        yourMessage += "Filter Selected: " + filtervals + "\n";
      } else {
        yourMessage += "Filter Selected: " + "No Filter Values selected" + "\n";
      }
      if (filterlvls != "filterlvlNone") {
        yourMessage += "Filter Levels Selected: " + filterlvls + "\n";
      }
      yourMessage += "\nResolution: " + screen.width + "x" + screen.height + "\n";
      if (screen.width != window.outerWidth || screen.height != window.outerHeight)
        yourMessage += "Browser Resolution: " + window.outerWidth + "x" + window.outerHeight + "\n";
      yourMessage += "Zoom Level: " + Math.round(window.devicePixelRatio * 100) + "%\n";
      yourMessage += "User Agent: " + navigator.userAgent + "\n";
      document.location.href = sendermail +
        encodeURIComponent(subject) +
        "&body=" + encodeURIComponent(yourMessage);
    }
  }
}
</script>
<style scoped>
.errInfo {
  position: static;
  height: 157px
}

html,
body {
  margin: 0;
  padding: 0;
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

html *,
body * {
  box-sizing: border-box;
}

.error-image {
  position: relative;
  padding: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.error-image .error-image__outer-display {
  background: #B2D2DD;
  width: 400px;
  height: 225px;
  border-radius: 4px;
  padding: 20px;
}

.error-image .error-image__inner-display {
  background: #FFFFFE;
  height: 100%;
  position: relative;
}

.error-image .error-image__inner-display .error-image__header {
  background: #026B8F;
  height: 30px;
  padding: 5px;
  position: relative;
}

.error-image .error-image__inner-display .error-image__header .error-image__dots {
  background: #b60000;
  width: 8px;
  height: 8px;
  border-radius: 10px;
  position: relative;
}

.error-image .error-image__inner-display .error-image__header .error-image__dots:before,
.error-image .error-image__inner-display .error-image__header .error-image__dots:after {
  content: "";
  height: inherit;
  width: inherit;
  position: absolute;
  background: inherit;
  border-radius: inherit;
}

.error-image .error-image__inner-display .error-image__header .error-image__dots:before {
  left: 12px;
  background-color: #ffba00;
}

.error-image .error-image__inner-display .error-image__header .error-image__dots:after {
  left: 24px;
  background-color: #0dbc0d;
}

.error-image .error-image__inner-display .error-image__viewport {
  background: #FFFFFE;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% - 30px);
  padding: 20px 30px;
}

.darkTheme .error-image .error-image__inner-display .error-image__viewport {
  background: #262626 !important;
}

.error-image .error-image__inner-display .error-image__viewport .error-image__dashed-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font: 14pt sans-serif;
  color: #1e7895;
  font-weight: bold;
  background: linear-gradient(to right, #B2D2DD 50%, #fff 0%) top/15px 1px repeat-x, linear-gradient(#B2D2DD 50%, #fff 0%) right/1px 15px repeat-y, linear-gradient(to right, #B2D2DD 50%, #fff 0%) bottom/15px 1px repeat-x, linear-gradient(#B2D2DD 50%, #fff 0%) left/1px 15px repeat-y;
  /* left */
}

.darkTheme .error-image .error-image__inner-display .error-image__viewport .error-image__dashed-container {
  color: #5bdfe3;
  background: linear-gradient(to right, #B2D2DD 50%, #262626 0%) top/15px 1px repeat-x, linear-gradient(#B2D2DD 50%, #262626 0%) right/1px 15px repeat-y, linear-gradient(to right, #B2D2DD 50%, #262626 0%) bottom/15px 1px repeat-x, linear-gradient(#B2D2DD 50%, #262626 0%) left/1px 15px repeat-y;
}

.error-image .error-image__stand {
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.error-image .error-image__stand .error-image__top-stand {
  background: #026B8F;
  width: 80px;
  height: 40px;
}

.error-image .error-image__stand .error-image__bottom-stand {
  background: #B2D2DD;
  height: 10px;
  width: 250px;
}

.error-image .error-image__addons {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.error-image .error-image__addons .error-image__plus {
  position: absolute;
}

.error-image .error-image__addons .error-image__plus:before,
.error-image .error-image__addons .error-image__plus:after {
  content: "";
  height: 15px;
  width: 4px;
  position: absolute;
  background: inherit;
  border-radius: 2px;
}

.error-image .error-image__addons .error-image__plus:before {
  transform: rotate(90deg);
}

.error-image .error-image__addons .error-image__circle {
  border: 3px solid;
  background: transparent;
  border-radius: 15px;
  height: 15px;
  width: 15px;
  position: absolute;
}

.error-image .error-image__addons>[class*=error-image__]:nth-child(1) {
  -webkit-animation: 1s sparkle -2.4s infinite;
  animation: 1s sparkle -2.4s infinite;
}

.error-image .error-image__addons>[class*=error-image__]:nth-child(2) {
  -webkit-animation: 4s sparkle -1.1s infinite;
  animation: 4s sparkle -1.1s infinite;
}

.error-image .error-image__addons>[class*=error-image__]:nth-child(3) {
  -webkit-animation: 2s sparkle -1s infinite;
  animation: 2s sparkle -1s infinite;
}

.error-image .error-image__addons>[class*=error-image__]:nth-child(4) {
  -webkit-animation: 4s sparkle -0.7s infinite;
  animation: 4s sparkle -0.7s infinite;
}

.error-image .error-image__addons>[class*=error-image__]:nth-child(5) {
  -webkit-animation: 1s sparkle -0.7s infinite;
  animation: 1s sparkle -0.7s infinite;
}

.error-image .error-image__addons>[class*=error-image__]:nth-child(6) {
  -webkit-animation: 2s sparkle -2.3s infinite;
  animation: 2s sparkle -2.3s infinite;
}

.error-image .error-image__addons>[class*=error-image__]:nth-child(7) {
  -webkit-animation: 5s sparkle -4.5s infinite;
  animation: 5s sparkle -4.5s infinite;
}

.error-image .error-image__addons>[class*=error-image__]:nth-child(8) {
  -webkit-animation: 4s sparkle -4.5s infinite;
  animation: 4s sparkle -4.5s infinite;
}

.error-image .error-image__addons>[class*=error-image__]:nth-child(9) {
  -webkit-animation: 1s sparkle -3.8s infinite;
  animation: 1s sparkle -3.8s infinite;
}

.error-image .error-image__addons>[class*=error-image__]:nth-child(1) {
  bottom: 60px;
  left: 100px;
  background: #8f0202;
}

.error-image .error-image__addons>[class*=error-image__]:nth-child(2) {
  bottom: 150px;
  left: 20px;
  background: #ddb2b2;
}

.error-image .error-image__addons>[class*=error-image__]:nth-child(3) {
  bottom: 250px;
  left: 0px;
  border-color: #8f0202;
}

.error-image .error-image__addons>[class*=error-image__]:nth-child(4) {
  top: 10px;
  left: 150px;
  border-color: #ddb2b2;
}

.error-image .error-image__addons>[class*=error-image__]:nth-child(5) {
  top: 0;
  left: 300px;
  background: #8f0202;
}

.error-image .error-image__addons>[class*=error-image__]:nth-child(6) {
  top: 20px;
  right: 100px;
  border-color: #ddb2b2;
}

.error-image .error-image__addons>[class*=error-image__]:nth-child(7) {
  bottom: 250px;
  right: 30px;
  background: #ddb2b2;
}

.error-image .error-image__addons>[class*=error-image__]:nth-child(8) {
  bottom: 80px;
  right: 15px;
  border-color: #ddb2b2;
}

.error-image .error-image__addons>[class*=error-image__]:nth-child(9) {
  bottom: 40px;
  right: 100px;
  border-color: #8f0202;
}

@-webkit-keyframes sparkle {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }

  100% {
    opacity: 1;
  }
}

@keyframes sparkle {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }

  100% {
    opacity: 1;
  }
}
</style>